import { Gear, GitBranch, OpenAiLogo, Trash } from '@phosphor-icons/react'
import React from 'react'

const ProjectActions = ({
  delete_project_path,
  sources_project_path,
  settings_project_path,
}) => {
  return (
    <div className="dropdown dropdown-end">
      <label tabIndex="0" className="btn btn-outline btn-secondary">
        <div className="flex gap-2 items-center">
          <Gear weight="fill" color="teal" size={16}/>
          <span className="text-sm">Settings</span>
        </div>
      </label>
      <ul tabIndex="0"
          className="dropdown-content z-[50] menu p-2 shadow bg-base-100 rounded-box w-52 m-2 border border-gray-200">
        <a href={settings_project_path} data-turbo-frame="_top"
           className="flex gap-2 items-center p-2 hover:bg-base-200 rounded-lg">
          <OpenAiLogo weight="fill" color="teal" size={16}/>
          <span>Agent Settings</span>
        </a>

        <a href={sources_project_path} data-turbo-frame="_top"
           className="flex gap-2 items-center p-2 hover:bg-base-200 rounded-lg">
          <GitBranch weight="fill" color="teal" size={16}/>
          <span>Sources</span>
        </a>

        <a href={delete_project_path} data-turbo-frame="_top"
           className="flex gap-2 items-center p-2 hover:bg-error rounded-lg">
          <Trash weight="fill" color="red" size={16}/>
          <span>Delete Project</span>
        </a>
      </ul>
    </div>
  )
}

export default ProjectActions